// extracted by mini-css-extract-plugin
export default {"card":"cards_card__8PyOX","cardimage":"cards_cardimage__kF1W5","image":"cards_image__MhLzF","category":"cards_category__vJLWY","heading":"cards_heading__JW46X"};